import React from "react";
import { Card, ListGroup, Container, Row, Col } from "react-bootstrap";

interface ImageCardWithListProps {
  imageUrl: string;
  imageAlt?: string;
  listItems: string[];
  cardTitle?: string;
  cardText?: string;
}

const ImageCardWithList: React.FC<ImageCardWithListProps> = ({
  imageUrl,
  imageAlt = "Card image",
  listItems,
  cardTitle = "Card Title",
  cardText = "Some example text to build on the card title and make up the bulk of the card's content."
}) => {
  return (
    <Container className="my-4">
      <Row>

        
        
        {/* Left Side: Image Card */}
        <Col md={6}>
          <Card>
            <Card.Img variant="top" src={imageUrl} alt={imageAlt} />
            <Card.Body>
              <Card.Title>{cardTitle}</Card.Title>
              <Card.Text>{cardText}</Card.Text>
            </Card.Body>
          </Card>
        </Col>

        
        
        {/* Right Side: List */}
        <Col md={6}>
          <h4 className="mb-3">Item List</h4>
          <ListGroup>
            {listItems.map((item, index) => (
              <ListGroup.Item key={index}>{item}</ListGroup.Item>
            ))}
          </ListGroup>
        </Col>

      </Row>
    </Container>
  );
};

export default ImageCardWithList;
